import React from 'react';
import PropTypes from 'prop-types';
import Icon from './icon';

function ShareBulletIcon(props) {
  const { size } = props;

  return (
    <Icon
      name="share"
      viewBox="0 0 25 25"
      size={size}
      {...props}
      renderComponent={() => (
        <g id="Group-8">
          <circle id="Oval" fill="#F52828" cx="12" cy="12" r="12" />
          <g
            id="Group-2"
            transform="translate(7.500000, 6.500000)"
            stroke="#F7F7F7"
            strokeWidth="1.5"
          >
            <polyline
              id="Path-7"
              fill="#F52828"
              points="-3.55501217e-13 4.06205162 -3.55501217e-13 10.4937496 8.54601996 10.4937496 8.54601996 4.06205162"
            />
            <polyline
              id="Path-8"
              points="6.50554753 2.23253755 4.27300998 8.9688449e-13 2.04047243 2.23253755"
            />
            <line
              x1="4.27300998"
              y1="-1.01628839e-12"
              x2="4.27300998"
              y2="7.28042115"
              id="Path-9"
            />
          </g>
        </g>
      )}
    />
  );
}

ShareBulletIcon.propTypes = {
  size: PropTypes.number,
};

ShareBulletIcon.defaultProps = {
  size: 25,
};

export default ShareBulletIcon;
